// extracted by mini-css-extract-plugin
module.exports = {"ad":"Leader_ad__bTTc8"};